import {
  IPartnerTestAccount,
  PartnerTestAccountStatus,
} from '@principle-theorem/principle-core/interfaces';
import { AtLeast } from '@principle-theorem/shared';

export class PartnerTestAccount {
  static init(
    overrides: AtLeast<
      IPartnerTestAccount,
      'name' | 'region' | 'seedFileName' | 'userRef'
    >
  ): IPartnerTestAccount {
    return {
      deleted: false,
      status: PartnerTestAccountStatus.Provisioning,
      ...overrides,
    };
  }
}
